import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import showdown from 'showdown';
import {
  getModuleByStep,
  answerModuleQuestion,
  getModuleQuestionsByType,
} from '../../../actions/moduleActions';
import * as Survey from 'survey-react';
import 'survey-react/survey.css';
import '../../../index.css';
import Loader from '../../../components/Loader';
import Message from '../../../components/Message';
import { useTranslation } from 'react-i18next';
import ContactHelp from '../ContactHelp';
import NavigationPatient from '../NavigationPatientHeader';
import { ButtonNavBar } from '../buttonNavBar';

function ActionModule5({ history }) {
  useEffect(() => {
    var refresh = window.localStorage.getItem('refresh');
    if (!refresh) {
      window.location.reload();
      window.localStorage.setItem('refresh', '1');
    }
  }, []);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.fontR);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const step = urlParams.get('step');
    const patientId = urlParams.get('patientId');
    if (patientId) {
      setPatientId(patientId);
    }
    if (step) {
      setStep(Number(step));
      dispatch(getModuleByStep({ step, myType: 'action', language }));
      dispatch(getModuleQuestionsByType({ step, myType: 'action', language }));
    }
  }, [language, dispatch]);

  const { module, questions, moduleAnswer, loading } = useSelector(
    (state) => state.moduleR
  );
  const [allQuestions, setAllQuestions] = useState({
    requiredText: '',
    pages: [],
    showQuestionNumbers: 'off',
  });
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(null);
  const [patientId, setPatientId] = useState('');
  const [currentQuestion, setCurrentQuestion] = useState({});
  const [currentStep] = useState(0);
  const [allQArr, setAllQArr] = useState({});
  const [message, setMessage] = useState('');

  // console.log('questions',questions.length)

  useEffect(() => {
    setMessage('');
    let questionsFiltered = [];
    if (questions && questions.length) {
      let json = {
        requiredText: '',
        pages: [],
        showQuestionNumbers: 'off',
      };

      let data = questions[0].filter((e) => e.rank < 6);
      questionsFiltered = [data];

      const newArr = {};
      const allR = [];
      questionsFiltered.forEach((q, index) => {
        newArr[index] = {}; // set answer object
        allR.push(index);
        let sortedD;
        if (q.length > 1) {
          sortedD = q.sort((a, b) => a.rank - b.rank);
        } else {
          sortedD = [q];
        }
        json.pages.push({ questions: sortedD });
      });

      setAllQuestions(json);
      setAllQArr(json);
      if (json.pages.length) {
        setCurrentQuestion(json.pages[0] && json.pages[0].questions[0]);
      }
    }
  }, [questions]);

  useEffect(() => {
    if (moduleAnswer && submitted) {
      return history.push(
        '/patient/action/completion' +
          window.location.search +
          `&questions=${questions.length}`
      );
    }
  }, [moduleAnswer, submitted, step]);

  var survey = new Survey.Model(allQuestions);
  survey.locale = language === 'malay' ? 'id' : 'en';
  Survey.StylesManager.applyTheme('modern');

  survey.onUpdateQuestionCssClasses.add(function (survey, options) {
    var classes = options.cssClasses;

    classes.mainRoot += ' sv_qstn-action';
    classes.root = ' sq-root-action';
    classes.title += ' sq-title';
    classes.item += ' sq-item';
    classes.label += ' sq-label';
    classes.number += ' action-question_num';
    classes.description += ' sv_action_description sv_action_description-m5 ';
    if (options.question.getType() === 'text') {
      classes.root += ' sq-root-m5';
    }
    if (options.question.isRequired) {
      classes.title += ' sq-title-required';
      classes.root += ' sq-root-required';
    }
  });

  var converter = new showdown.Converter();
  converter.setOption('simpleLineBreaks', true);

  survey.onTextMarkdown.add(function (survey, options) {
    var str = converter.makeHtml(options.text);
    str = str.substring(3);
    str = str.substring(0, str.length - 4);
    options.html = str;
  });

  function onComplete() {
    let data = {
      step: step,
      patientId: patientId, // replace this id with real user id
      answer: {},
      lastQuestion: true,
      myType: 'action',
      language: language,
    };
    setSubmitted(true);
    dispatch(answerModuleQuestion(data));
  }

  useEffect(() => {
    const data =
      currentStep && Object.keys(allQArr).length && allQArr.pages[currentStep];
    if (data) {
      setCurrentQuestion(data.questions[0]);
      setAllQuestions({
        requiredText: '',
        pages: [data],
        showQuestionNumbers: 'off',
      });
    }
  }, [currentStep, allQArr]);

  return (
    <div className="small-screen-center main-wrapper-div">
      <div
        style={{
          position: 'absolute',
          width: '100%',
          zIndex: '10',
          maxWidth: '500px',
        }}
      >
        <NavigationPatient />
      </div>

      {loading ? <Loader /> : null}
      <>
        <div className="main-body-height">
          <div className="pb-3 position-relative">
            <img
              src={module ? module.photoUrl : ''}
              style={{
                width: '100%',
                height: '12rem',
                objectFit: 'cover',
              }}
              alt="header-img"
            />

            <div className="header-text-render mx-4">
              <div className="trial-header-text mb-2">
                {module?.step < 3 ? t('Trial_Module') : t('Registered_Patient')}
              </div>
              <div className="main-header-text">
                {module && module.titleSecond}
              </div>
            </div>
          </div>

          <div className="main-body-height mx-3">
            <div className="sv_progress_bar_block">
              <div className="green-background"></div>
              <div className="green-background mx-3"></div>
              <div className="gray-background"></div>
            </div>
            {message ? (
              <div className="mx-2 my-2">
                <Message variant="danger" fullWidth={true}>
                  {message}
                </Message>
              </div>
            ) : null}

            <div className="mx-3 mt-3">
              <h3 className="fw-bold">{module?.actionTitle}</h3>
              <div className="py-3">
                {currentQuestion && currentQuestion.headerTitle}
              </div>
              <div>{currentQuestion && currentQuestion.mainQuestion}</div>
            </div>

            <Survey.Survey
              model={survey}
              showCompletedPage={false}
              showNavigationButtons={false}
            />

            <div
              className="mx-3 mt-3"
              style={{ textAlign: 'justify', lineHeight: '1rem' }}
            >
              {t('module5_action_extra_text')}
            </div>

            <div className=" mx-3 mt-3 pb-3 mb-4">
              <button
                onClick={() => onComplete()}
                className="mt-2 custom-primary-button"
              >
                {t('ContinueM')}
              </button>
            </div>
          </div>
        </div>

        <ButtonNavBar />
        <ContactHelp />
      </>
    </div>
  );
}

export default ActionModule5;
